<template>
  <div class="prevent-select unit-graph-page">
    <b-row>
      <b-col :md="isRightLibraryPanelHidden ? '12' : '8'">
        <span class="float-right text-primary hand" v-if="isRightLibraryPanelHidden" @click="toggleRightLibraryPanel">
          <i class="bx bx-show "></i>
          {{ $t("unit.show-library") }}
        </span>

        <h2>{{ $t("unit.organizational-units") }}</h2>
        <content-loading v-if="loading"></content-loading>
        <div class="d-flex justify-content-center mb-4">
          <div class="w-25 mr-4 ">
            <filter-select id="unitFilter" ref="unitFilter" :selected="unitFilter" @filter="onUnitSearch" @changed="onUnitSelect" :placeholder="$t('unit.select')" />
          </div>
          <div class="w-25 ">
            <filter-select
              id="departmentFilter"
              ref="departmentFilter"
              :selected="departmentFilter"
              @filter="onDepartmentSearch"
              @changed="onDepartmentSelect"
              :placeholder="$t('department.select')"
            />
          </div>
        </div>

        <flowy :nodes="nodes" :beforeMove="beforeMove" :beforeAdd="beforeAdd" @add="add" @move="move" @remove="remove" @expand="expand" @drag-start="onDragStart"></flowy>
      </b-col>

      <b-col md="4" v-show="!isRightLibraryPanelHidden" class="border-left">
        <b-row>
          <b-col md="12">
            <span class="float-right text-primary hand " v-if="!isRightLibraryPanelHidden" @click="toggleRightLibraryPanel">
              <i class="bx bx-show "></i>
              {{ $t("common.hide") }}
            </span>
          </b-col>
        </b-row>
        <simplebar style="z-index:1000; max-height:800px; min-width: 400px;">
          <div>
            <b-tabs class="text-left badge font-size-11 hand " v-model="index">
              <!-- Sekmentasyon Başlangıcı -->

              <b-tab class="badge-lg text-secondary" :title="$t('department.text')" id="sidebar-department" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                <div class="mt-4">
                  <h3><i class="mdi mdi-storefront-outline"></i> {{ $t("department.plural") }}</h3>

                  <div class="app-search d-none d-lg-block pt-0">
                    <div class="position-relative">
                      <input id="search-department" v-model="departmentLibraryRequestSearch" type="text" class="form-control bg-white" placeholder="Ara..." />
                      <span class="bx bx-search-alt"></span>
                    </div>
                  </div>
                  <flowy-new-block
                    v-for="(block, index) in departmentBlocks"
                    :key="block.preview.title + index"
                    class="q-mr-md"
                    @drag-start="onDragStartNewBlock"
                    @drag-stop="onDragStopNewBlock"
                  >
                    <template v-slot:preview>
                      <graph-block :title="block.preview.title" :description="block.preview.description">
                        <i v-if="block.preview.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                        <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
                      </graph-block>
                    </template>
                    <template v-slot:node="{}">
                      <graph-node
                        :title="block.node.title"
                        :description="block.node.description"
                        :custom-attribute="block.node.canBeAdded"
                        :entity="block.node.entity"
                        type="Department"
                      />
                    </template>
                  </flowy-new-block>

                  <div v-if="departmentLibraryPagination" class="row">
                    <div class="col">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="departmentLibraryRequestPage"
                          :total-rows="departmentLibraryPagination.totalDocs"
                          :per-page="departmentLibraryPagination.limit"
                          limit="10"
                          size="sm"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab class="badge-lg text-secondary" :title="$t('department.new')" id="sidebar-new-department" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                <div class="mt-3" style="height:600px">
                  <DepartmentForm :hide-library="true" @onDepartmentSave="fetchDepartmentLibraryItems" />
                </div>
              </b-tab>

              <b-tab class="badge-lg text-secondary" :title="$t('unit.text')" id="sidebar-unit">
                <div>
                  <br style="clear:both" />

                  <h3><i class="mdi mdi-office-building"></i> {{ $t("unit.plural") }}</h3>

                  <div class="app-search d-none d-lg-block pt-0">
                    <div class="position-relative">
                      <input id="search-unit" v-model="libraryRequestSearch" type="text" class="form-control bg-white" placeholder="Ara..." />
                      <span class="bx bx-search-alt"></span>
                    </div>
                  </div>
                  <flowy-new-block
                    v-for="(block, index) in blocks"
                    :key="block.preview.title + index"
                    class="q-mr-md"
                    @drag-start="onDragStartNewBlock"
                    @drag-stop="onDragStopNewBlock"
                  >
                    <template v-slot:preview>
                      <graph-block :title="block.preview.title" :description="block.preview.description">
                        <i v-if="block.preview.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                        <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
                      </graph-block>
                    </template>
                    <template v-slot:node="{}">
                      <graph-node
                        :title="block.node.title"
                        :description="block.node.description"
                        :custom-attribute="block.node.canBeAdded"
                        :entity="block.node.entity"
                        type="Unit"
                      />
                    </template>
                  </flowy-new-block>

                  <div v-if="libraryPagination" class="row">
                    <div class="col">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="libraryRequestPage"
                          :total-rows="libraryPagination.totalDocs"
                          :per-page="libraryPagination.limit"
                          limit="10"
                          size="sm"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="badge-lg text-secondary" :title="$t('unit.new')" id="sidebar-new-unit" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                <div class="mt-3 mb-5">
                  <Form :hide-library="true" @onUnitSave="fetchLibraryItems" />
                </div>
              </b-tab>

              <recommendation-items :draggable="false" level="department" libraryScopedState="department" organizationScopedState="organizationDepartment" />

              <b-tab
                v-if="recommendationBlocks.length > 0"
                class="badge-lg text-secondary"
                :title="$t('common.recommendations')"
                id="sidebar-recomendations"
                :icon="'mdi mdi-plus'"
                @hidden="rightPanelClosed"
              >
                <div class="mt-4">
                  <h3><i class="mdi mdi-storefront-outline"></i> {{ $t("department.recommendations") }}</h3>

                  <flowy-new-block v-for="(block, index) in recommendationBlocks" :key="index" class="q-mr-md" @drag-start="onDragStartNewBlock" @drag-stop="onDragStopNewBlock">
                    <template v-slot:preview>
                      <graph-block :title="block.preview.title" :description="block.preview.description">
                        <i v-if="block.preview.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                        <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
                      </graph-block>
                    </template>
                    <template v-slot:node="{}">
                      <graph-node
                        :title="block.node.title"
                        :description="block.node.description"
                        :custom-attribute="block.node.canBeAdded"
                        :entity="block.node.entity"
                        type="Department"
                      />
                    </template>
                  </flowy-new-block>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </simplebar>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RecommendationItems from "@cc/recommendation-items";
import Simplebar from "simplebar-vue";
import DepartmentForm from "../department/organization-department-form";
import RecommendationBoxes from "../entity/component/recommendation-boxes.vue";
import Form from "./organization-unit-form";

export default {
  components: { Form, DepartmentForm, Simplebar, RecommendationBoxes, RecommendationItems },
  data() {
    return {
      loading: false,
      holder: [],
      dragging: false,
      nodes: [],
      isRightLibraryPanelHidden: true,
      index: 0,
      showRecommendationBoxes: true,
      libraryScopedState: "department",
      departmentFilter: undefined,
      unitFilter: undefined,
    };
  },

  computed: {
    organization() {
      return this.$store.getters["organization/selected"];
    },
    blocks() {
      const pagination = this.$store.getters[`unit/pagination`];
      if (!pagination) return [];

      return pagination.docs.map((i) => ({
        preview: {
          ...i,
          title: this.$options.filters.translate(i.name),
        },
        node: {
          entity: i,
          title: this.$options.filters.translate(i.name),
          description: "",
        },
      }));
    },

    departmentBlocks() {
      const pagination = this.$store.getters[`department/pagination`];
      if (!pagination) return [];

      return pagination.docs.map((i) => ({
        preview: {
          ...i,
          title: this.$options.filters.translate(i.name),
        },
        node: {
          entity: i,
          title: this.$options.filters.translate(i.name),
          description: "",
        },
      }));
    },

    recommendationBlocks() {
      const pagination = this.$store.getters[`${this.libraryScopedState}/recommendations`];
      if (!pagination) return [];

      return pagination.docs.map((i) => ({
        preview: {
          ...i,
          title: this.$options.filters.translate(i.name),
        },
        node: {
          entity: i,
          title: this.$options.filters.translate(i.name),
          description: "",
        },
      }));
    },

    libraryPagination() {
      return this.$store.getters[`unit/pagination`];
    },
    isLibraryLoading() {
      return this.$store.getters[`unit/isLoading`];
    },
    libraryRequest() {
      return this.$store.state.unit.request;
    },

    departmentLibraryPagination() {
      return this.$store.getters[`department/pagination`];
    },
    isDepartmentLibraryLoading() {
      return this.$store.getters[`department/isLoading`];
    },
    departmentLibraryRequest() {
      return this.$store.state.department.request;
    },

    libraryRequestPage: {
      get() {
        return this.$store.state.unit.request.options.page;
      },
      set(value) {
        this.$store.commit("unit/request", {
          ...this.$store.state.unit.request,
          options: {
            ...this.$store.state.unit.request.options,
            page: value,
          },
        });
        this.fetchLibraryItems();
      },
    },
    libraryRequestSearch: {
      get() {
        return this.$store.state.unit.request.query.name.value;
      },
      set(value) {
        this.$store.commit("unit/request", {
          ...this.$store.state.unit.request,
          query: {
            name: { value },
          },
        });
        this.fetchLibraryItems();
      },
    },

    departmentLibraryRequestPage: {
      get() {
        return this.$store.state.department.request.options.page;
      },
      set(value) {
        this.$store.commit("department/request", {
          ...this.$store.state.department.request,
          options: {
            ...this.$store.state.department.request.options,
            page: value,
          },
        });
        this.fetchDepartmentLibraryItems();
      },
    },
    departmentLibraryRequestSearch: {
      get() {
        return this.$store.state.department.request.query.name.value;
      },
      set(value) {
        this.$store.commit("department/request", {
          ...this.$store.state.department.request,
          query: {
            name: { value },
          },
        });
        this.fetchDepartmentLibraryItems();
      },
    },
  },

  watch: {
    departmentBlocks: {
      deep: true,
      handler() {
        this.$forceUpdate(); //!important for rerender draggable items
      },
    },
    blocks: {
      deep: true,
      handler() {
        this.$forceUpdate(); //!important for rerender draggable items
      },
    },
  },

  mounted() {
    this.fetchLibraryItems();
    this.fetchDepartmentLibraryItems();
    this.loadNodes();
    this.$root.$on("edit", this.edit);
    this.$root.$on("expand", this.expand);
  },
  methods: {
    async onDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(item) {
      this.departmentFilter = item;
      this.loadNodes();
    },

    async onUnitSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationUnit/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onUnitSelect(item) {
      this.unitFilter = item;
      this.loadNodes();
    },

    toggleRightLibraryPanel() {
      this.isRightLibraryPanelHidden = !this.isRightLibraryPanelHidden;
    },

    edit(node) {
      this.isRightLibraryPanelHidden = false;

      if (node.type == "Department") {
        this.index = 1;
        this.$store.commit("organizationDepartment/editedEntity", node.entity);
      } else {
        this.index = 3;
        this.$store.commit("organizationUnit/editedEntity", node.entity);
      }
    },
    expand(node) {
      this.$router.push(`/unit/${node.entity._id}/processes`);
    },
    rightPanelClosed() {
      this.$store.commit("organizationUnit/editedEntity", null);
      this.loadNodes();
      this.$store.dispatch("organizationDepartment/resetForm");
    },

    fetchLibraryItems() {
      this.$store.dispatch(`unit/paginate`, this.libraryRequest);
      this.loadNodes();
    },

    fetchDepartmentLibraryItems() {
      this.$store.dispatch(`department/paginate`, this.departmentLibraryRequest);
      this.loadNodes();
    },

    async loadNodes() {
      this.loading = true;
      const organization = this.$store.getters[`organization/selected`];

      const { data } = await this.$store.dispatch("organizationUnit/graph", { department: this.departmentFilter, unit: this.unitFilter });

      const items = [
        {
          id: organization._id,
          parentId: -1,
          nodeComponent: "graph-node",
          icon: "bx bxs-school",
          root: true,
          data: {
            text: this.$options.filters.translate(organization.name),
            title: this.$options.filters.translate(organization.name),
            description: null,
          },
        },

        ...data.map((i) => ({
          id: i._id,
          parentId: i.parentId,
          nodeComponent: "graph-node",
          icon: i.type == "Unit" ? "mdi mdi-office-building" : "mdi mdi-storefront-outline",
          type: i.type,
          data: {
            text: this.$options.filters.translate(i.name),
            title: this.$options.filters.translate(i.name),
            description: null,
          },
          entity: i,
        })),
      ];

      this.nodes = items;

      this.loading = false;
    },

    //
    onDragStartNewBlock(event) {
      // contains all the props and attributes passed to graph-node
      const { props } = event;
      this.newDraggingBlock = props;
    },
    onDragStopNewBlock(event) {
      this.newDraggingBlock = null;
    },
    // REQUIRED
    beforeMove({ to, from }) {
      // called before moving node (during drag and after drag)
      // indicator will turn red when we return false
      // from is null when we're not dragging from the current node tree
      if (to && to.type == "Department") {
        return false;
      }
      // we cannot drag upper parent nodes in this demo
      if (from && from.parentId === -1) {
        return false;
      }
      // we're adding a new node (not moving an existing one)
      if (from === null) {
        // we've passed this attribute to the graph-node
        if (this.newDraggingBlock["custom-attribute"] === false) {
          return false;
        }
      }

      let parentNode = this.nodes.find((n) => n.id == to.parentId);
      let i = 0;
      while (parentNode) {
        if (parentNode.id == from?.id) {
          return false;
        }
        parentNode = this.nodes.find((n) => n.id == parentNode.parentId);

        if (i++ > 40) return false;
      }

      return true;
    },
    // REQUIRED
    beforeAdd() {
      // called before moving node (during drag and after drag)
      // indicator will turn red when we return false
      // from is null when we're not dragging from the current node tree

      // we've passed this attribute to the graph-node
      if (this.newDraggingBlock["custom-attribute"] === false) {
        return false;
      }

      return true;
    },
    randomInteger() {
      return Math.floor(Math.random() * 10000) + 1;
    },
    generateId(nodes) {
      let id = this.randomInteger();
      // _.find is a lodash function
      while (_.find(nodes, { id }) !== undefined) {
        id = this.randomInteger();
      }
      return id;
    },
    addNode(_event) {
      const id = this.generateId();
      this.nodes.push({
        ..._event.node,
        id,
      });
    },
    async remove(event) {
      const id = event.node.entity._id;
      const name = event.node.entity.name;

      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        if (event.node.type == "Department") {
          await this.$store.dispatch("organizationDepartment/delete", id);
        } else {
          await this.$store.dispatch("organizationUnit/delete", id);
        }
        this.loadNodes();

        this.$toast.success("'" + this.$options.filters.translate(name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(name) + "' Silinemedi" });
      }
    },
    async move(event) {
      const item = event.dragged.entity;
      const parentId = this.organization._id == event.to.id ? null : event.to.id;
      item.parent = parentId ? { _id: parentId } : null;

      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        if (event.dragged.type == "Department") {
          await this.$store.dispatch("organizationDepartment/save", {
            ...item,
            unit: item.parent,
          });
        } else {
          await this.$store.dispatch("organizationUnit/save", {
            ...item,
          });
        }

        this.loadNodes();
        this.$toast.success("Başarılı");
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async add(event) {
      const libraryItem = event.node.data.entity;
      const parentId = this.organization._id == event.node.parentId ? null : event.node.parentId;

      try {
        if (event.node.data.type == "Department") {
          await this.$store.dispatch(`organizationDepartment/addFromLibrary`, {
            libraryItem,
            unitId: parentId,
          });
        } else {
          await this.$store.dispatch(`organizationUnit/addFromLibrary`, {
            libraryItem,
            parentId,
          });
        }

        this.$toast.success("'" + this.$options.filters.translate(libraryItem.name) + "' Eklendi");
        this.loadNodes();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    onDragStart(event) {
      this.dragging = true;
    },

    copyToForm(item) {
      this.$store.commit(`organizationDepartment/copingEntity`, { ...item, libraryItem: item, _id: undefined });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-department");
    },
    async paginate() {
      await this.$store.dispatch("organizationDepartment/paginate", this.request);
    },
  },
};
</script>

<style lang="scss">
.prevent-select * {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

.flowy-block.draggable-mirror {
  opacity: 0.6;
}

$borderTextColor1: #ff7c48;
$bgColor1: #ffeee8;

$borderTextColor2: #32c753;
$bgColor2: #e8ffed;

$borderTextColor3: #c645ff;
$bgColor3: #f8e8ff;

$borderTextColor4: #4dd4ff;
$bgColor4: #e8f4ff;

.flowy-drag-handle {
  .card {
    border-radius: 12px;
    overflow: hidden;
  }

  .card-body {
    text-align: left;
  }

  h6 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.3rem;
    font-size: 15px !important;
    text-align: center;

    i {
      font-size: 22px !important;
    }
  }

  &.level1 {
    .card {
      border: 2px solid $borderTextColor1 !important;
    }

    .card-body {
      background-color: $bgColor1 !important;
    }

    h6 {
      color: $borderTextColor1 !important;
    }
  }

  &.level2 {
    .card {
      border: 2px solid $borderTextColor2 !important;
    }

    .card-body {
      background-color: $bgColor2 !important;
    }

    h6 {
      color: $borderTextColor2 !important;
    }
  }

  &.level3 {
    .card {
      border: 2px solid $borderTextColor3 !important;
    }

    .card-body {
      background-color: $bgColor3 !important;
    }

    h6 {
      color: $borderTextColor3 !important;
    }
  }

  &.level4 {
    .card {
      border: 2px solid $borderTextColor4 !important;
    }

    .card-body {
      background-color: $bgColor4 !important;
    }

    h6 {
      color: $borderTextColor4 !important;
    }
  }
}

#search-department {
  color: black;
}

#search-unit {
  color: black;
}
</style>
